import * as TimeModalContent from './time-modal-content';

export const TimePickerModalContent = {
  ...TimeModalContent,
  DoneBtn: 'done-btn',
  CancelBtn: 'cancel-btn',
} as const;
